import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	Input,
	OnInit
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { LoggerService } from '@services/logger/logger.service';

@Component({
	selector: 'app-inline-errors',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [
		`
			:host:empty {
				display: none;
			}
		`
	],
	template: `
		<div
			class="text-danger inline-error-text"
			*ngIf="fieldLocal?.errors && fieldLocal.dirty && fieldLocal.invalid"
		>
			<span *ngFor="let e of errorKeys">{{ getErrorMessage(e) }}</span>
		</div>
	`
})
export class InlineErrorsComponent implements OnInit {
	formLocal: FormGroup;
	fieldLocal: FormControl;
	fieldLocalName: string;
	messagesLocal: {};
	public errorKeys = null;
	@Input()
	set form(form: FormGroup) {
		if (!form) return;
		this.formLocal = form;
	}

	@Input()
	set fieldName(name) {
		this.fieldLocalName = name;
	}

	@Input()
	set errorMessages(err: {}) {
		this.messagesLocal = err;
	}

	constructor(
		private log: LoggerService,
		private cd: ChangeDetectorRef,
		private translate: TranslateService
	) {}

	ngOnInit() {
		if (!this.formLocal || !this.fieldLocalName) return;
		this.cd.detach();
		this.cd.detectChanges();
		this.fieldLocal = <FormControl>this.formLocal.get(this.fieldLocalName);
		this.fieldLocal.valueChanges.subscribe(res => {
			this.errorKeys = Object.keys(this.fieldLocal.errors || {});
			this.cd.detectChanges();
		});
	}

	getErrorMessage(key) {
		if (
			_.has(this.messagesLocal, this.fieldLocalName) &&
			!_.has(this.messagesLocal[this.fieldLocalName], key)
		) {
			this.log.log(`no phrase for this error: ${key}`);
		}
		return _.has(this.messagesLocal, this.fieldLocalName)
			? _.get(this.messagesLocal, `${this.fieldLocalName}.${key}`)
			: this.translate.instant(`inlineErrors.${key}`);
	}
}
